export function tooltipHide(tip) {
  tip.transition().duration(500).style('opacity', '0').style('display', 'none')
}

export function tooltipShow(tip, d, x, id) {
  tip
    .html('<div class="cb-tooltip-inner"><p>' + d.tip + '</p></div>')
    .style('left', x + document.getElementById(id).offsetLeft + 'px')
    .style('bottom', '64px')
    .transition() //Opacity transition when the tooltip appears
    .duration(350)
    .style('opacity', '1')
    .style('display', 'block')

  tip
    .select('.cb-tooltip-inner p')
    .style('font-size', '0.9em')
    .style('text-align', 'center')
    .style('margin-bottom', '0')
}

export function emptyElement(container) {
  if (!container) {
    console.log('Container is null or undefined')
    return
  }
  while (container.firstChild) {
    container.removeChild(container.lastChild)
  }
}

export function showSVGTooltip(tooltip, data) {
  tooltip
    .style('visibility', 'visible')
    .html(() => {
      let rows = ''
      for (const [key, value] of Object.entries(data)) {
        rows += `<tr><td class="tooltip-field">${key}: </td><td class="tooltip-value"><b>${value}</b></td></tr>`
      }
      return `<div class="cb-tooltip-inner"><table noborder><tbody align="left">${rows}</tbody></table></div>`
    })
    .transition()
    .duration(150)
    .style('opacity', 1)
    .style('display', 'block')
}
